import ReactGA from "react-ga"
 
export const initGA = () => {
  const gtag_id = process.env.REACT_APP_GTAG;
  ReactGA.initialize(gtag_id)
}
 
export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname })
  ReactGA.pageview(window.location.pathname)
}